// CRA 3 (webpack 4) cannot reliably parse ECharts ESM from node_modules.
// The compiled UMD bundle is ES5-safe.
// eslint-disable-next-line @typescript-eslint/no-var-requires
const echartsModule = require('echarts/dist/echarts')
const echarts = echartsModule && echartsModule.init
  ? echartsModule
  : echartsModule && echartsModule.default

export default echarts
